import { render, staticRenderFns } from "./SmsVerification.vue?vue&type=template&id=170e1674&scoped=true&"
import script from "./SmsVerification.vue?vue&type=script&lang=js&"
export * from "./SmsVerification.vue?vue&type=script&lang=js&"
import style0 from "./SmsVerification.vue?vue&type=style&index=0&id=170e1674&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "170e1674",
  null
  
)

export default component.exports